export function getIncludeInReports(event, fallback = true) {
    if (event && typeof event.isIncludedInReports === 'boolean') {
        return event.isIncludedInReports;
    }

    if (event && typeof event.includeInReports === 'boolean') {
        return event.includeInReports;
    }

    return fallback;
}

export function getReceiptUrl(event) {
    if (!event) {
        return null;
    }

    if (typeof event.receiptUrl === 'string' && event.receiptUrl.length > 0) {
        return event.receiptUrl;
    }

    if (typeof event.receiptURL === 'string' && event.receiptURL.length > 0) {
        return event.receiptURL;
    }

    if (typeof event.receipt_url === 'string' && event.receipt_url.length > 0) {
        return event.receipt_url;
    }

    if (event.receipt && typeof event.receipt.url === 'string' && event.receipt.url.length > 0) {
        return event.receipt.url;
    }

    return null;
}

export function normalizeIncludeInReports(event, fallback = true) {
    if (!event) {
        return event;
    }

    const includeInReports = getIncludeInReports(event, fallback);
    const normalizedEvent = Object.assign({}, event, {
        includeInReports,
        isIncludedInReports: includeInReports
    });

    const receiptUrl = getReceiptUrl(event);

    if (receiptUrl) {
        normalizedEvent.receiptUrl = receiptUrl;
    }

    return normalizedEvent;
}

export function toEventPayload(event, fallback = true) {
    if (!event) {
        return event;
    }

    const includeInReports = getIncludeInReports(event, fallback);
    const payload = Object.assign({}, event, {
        includeInReports
    });

    delete payload.receiptLocalUrl;
    delete payload.receiptFile;
    delete payload.receiptName;

    if (typeof payload.transactionDate !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(payload.transactionDate)) {
        delete payload.transactionDate;
    }

    return payload;
}



// WEBPACK FOOTER //
// ./src/application/util/event-report.util.js